import { LocalSession } from "@/utils/session";

export function sessionFromUrl(url: string | undefined | null): LocalSession | undefined {
  if (!url) return undefined;
  let url2;
  try {
    url2 = new URL(url);
  } catch (e) {
    return undefined;
  }
  const searchParams = url2.searchParams;
  const sig = searchParams.get("sig");
  const caseId = searchParams.get("case_id");
  if (!sig || !caseId) return undefined;
  return { signature: sig, caseId: caseId };
}
